import React, { useState, useEffect } from "react";
import ReactMapGL, { Marker, Popup, FlyToInterpolator } from "react-map-gl";
import styles from "./App.module.css";
import SymbolContainer from "./components/SymbolContainer";
import Picker from "./components/Picker";
import { connect, useDispatch, useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import { markerActions } from "./store/actions/marker.action";
import ControlPanel from "./components/Panel/ControlPanel";
import { easeCubic } from "d3-ease";

const App = (props) => {
  const dispatch = useDispatch();
  const overalldata = useSelector((state) => state.marker.markers);
  const [selectedData, setSelectedData] = useState(null);
  const [viewport, setViewport] = useState({
    latitude: 16.871311,
    longitude: 96.199379,
    width: "100vw",
    height: "100vh",
    zoom: 14,
  });
  const [pointer, setPointer] = useState({
    pointerLatitude: 16.871311,
    pointerLongitude: 96.199379,
  });

  const [state, setState] = React.useState({
    open: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, open });
  };

  useEffect(() => {
    setViewport({
      ...viewport,
      latitude: props.selectedState.lat,
      longitude: props.selectedState.lng,
      zoom: 14,
      transitionDuration: 4000,
      transitionInterpolator: new FlyToInterpolator(),
      transitionEasing: easeCubic,
    });
    // eslint-disable-next-line
  }, [props.selectedState]);

  const states = [
    { name: "Yangon(ရန်ကုန်)", value: "Yangon", lat: 16.86607, lng: 96.195129 },
    {
      name: "Mandalay(မန္တလေး)",
      value: "Mandalay",
      lat: 21.958828,
      lng: 96.089104,
    },
    {
      name: "Naypyitaw(နေပြည်တော်)",
      value: "Naypyitaw",
      lat: 19.79331,
      lng: 96.066399,
    },
    { name: "Pyay(ပြည်)", value: "Pyay", lat: 18.840603, lng: 95.257996 },
    { name: "Kathar(ကသာ)", value: "Kathar", lat: 24.18249, lng: 96.32776 },
    {
      name: "Monywar(မုံရွာ)",
      value: "Monywar",
      lat: 22.115299,
      lng: 95.137177,
    },
    { name: "Bago(ပဲခူး)", value: "Bago", lat: 17.3342, lng: 96.477829 },
    {
      name: "Mawlamyine(မော်လမြိုင်)",
      value: "Mawlamyine",
      lat: 16.45679,
      lng: 97.63744,
    },
  ];

  useEffect(() => {
    dispatch(markerActions.fetchAllMarkersOnMap());
    // eslint-disable-next-line
  }, []);

  const renderMarkersOnTypes = (types) => {
    switch (types?.type?.toLowerCase()) {
      case "police":
        return (
          <img
            src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613717385/mmlivemap/police_twgzsr.svg"
            alt="Police_position_mmcoup"
          />
        );
      case "army":
        return (
          <img
            src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613717388/mmlivemap/millitary_oqmggp.svg"
            alt=""
          />
        );
      case "water_tank":
        return (
          <img
            src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613888465/mmlivemap/3039889_xgizme.svg"
            alt=""
          />
        );
      case "medical_team":
        return (
          <img
            src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn4.iconfinder.com%2Fdata%2Ficons%2Fhospital-and-medical-v2%2F512%2Fcross_hospital_medicine_sign_health-512.png&f=1&nofb=1"
            alt=""
          />
        );
      case "block":
        return (
          <img
            src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613888684/mmlivemap/3100327_dzcbsi.svg"
            alt="mmlivemap_block"
          />
        );
      default:
        return (
          <img
            src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn0.iconfinder.com%2Fdata%2Ficons%2Fcommunication-material-design-icon-set%2F512%2Flocation-256.png&f=1&nofb=1"
            alt=""
          />
        );
    }
  };

  const _onClickMap = (map, evt) => {
    const latitude = map.lngLat[1];
    const longitude = map.lngLat[0];

    setPointer({
      ...pointer,
      pointerLatitude: latitude,
      pointerLongitude: longitude,
    }); // setState for Map UI Render

    const payload = {
      latitude,
      longitude,
    };
    dispatch(markerActions.pointerOnMap(payload));
    // dispatch for data add via redux store
  };

  const onClickMarkerOnMap = (e, data) => {
    e.preventDefault();
    setSelectedData(data);
    dispatch(markerActions.clickMarkerOnMap(data));
  };
  return (
    <div>
      <ControlPanel toggleDrawer={toggleDrawer} open={state.open} />
      <ReactMapGL
        {...viewport}
        style={{ position: "relative" }}
        mapboxApiAccessToken="pk.eyJ1IjoiaGFsY2hlc3RlciIsImEiOiJja2t4dXBhN2wybnVrMnZzMXF1aGowemp3In0.-96oCmdoEL1FCqWwBiEGkA"
        onViewportChange={setViewport}
        mapStyle="mapbox://styles/mapbox/dark-v9"
        onClick={_onClickMap}
        getCursor={(e) => "crosshair"}
      >
        {pointer && (
          <Marker
            latitude={pointer.pointerLatitude}
            longitude={pointer.pointerLongitude}
          >
            <button className={styles.marker_btn}>
              <img
                src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613889367/mmlivemap/715696_fmqqul.svg"
                alt=""
              />
            </button>
          </Marker>
        )}
        {overalldata.map((data, i) => (
          <Marker
            key={i}
            latitude={data.position[1]}
            longitude={data.position[0]}
          >
            <button
              className={styles.marker_btn}
              onClick={(e) => onClickMarkerOnMap(e, data)}
            >
              {renderMarkersOnTypes(data)}
            </button>
          </Marker>
        ))}

        {selectedData ? (
          <Popup
            latitude={selectedData.position[1]}
            longitude={selectedData.position[0]}
            className={styles.popup}
            onClose={() => {
              setSelectedData(null);
            }}
          >
            <div style={{ background: "#fff", padding: "0.3rem" }}>
              {/* <img
                src="https://cdn.discordapp.com/attachments/806930879708135439/811116543073189968/IMG_20210216_122717.jpg"
                style={{ width: "100%" }}
              /> */}
              <Typography>{selectedData.message}</Typography>
            </div>
          </Popup>
        ) : null}
      </ReactMapGL>
      <Picker
        states={states}
        toggleDrawer={toggleDrawer}
        open={state.open}
        isAuth={props.isAuth}
      />
      <SymbolContainer />
    </div>
  );
};

const mapStateToProps = ({ location, auth }) => {
  return {
    isAuth: auth.isAuth,
    selectedState: location.selectedState,
  };
};

export default connect(mapStateToProps)(App);
